import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Chip} from "@mui/material";

import {blue50, blue500, green50, green600, orange50, orange600} from "assets/jss/main";

const STATUS_COLORS = {
    to_handle: {backgroundColor: orange50, color: orange600},
    open: {backgroundColor: blue50, color: blue500},
    converted: {backgroundColor: green50, color: green600},
};

StatusChip.propTypes = {
    status: PropTypes.oneOf(["to_handle", "open", "converted"]),
};

/**
 * Where the conversation stands for the team, as Sylius reads it: to handle (a person is
 * expected), open, or converted (an assisted purchase was attributed to it, automatically).
 */
export function StatusChip({status}) {
    if (!status || !STATUS_COLORS[status]) {
        return null;
    }

    return (
        <Chip size="small" label={<FormattedMessage id={`personalShopper.status.${status}`} />} sx={{...STATUS_COLORS[status], fontWeight: 600}} />
    );
}

export default StatusChip;
